import type { FeatureFlags, FireflyRuntime } from "@sg-protect/federation-runtime";

// Runs before the user is identified, so flags are read without the user's LaunchDarkly context.
// Accepted on purpose: a route reachable by URL with its flag off is fine, and the loader is optional.
// Don't make it user-aware or defer the route until identification — every attempt was messier than this limit.
export function requireFeatureFlagLoader(runtime: FireflyRuntime, flagName: keyof FeatureFlags, defaultValue = false) {
    const enabled = runtime.getFeatureFlag(flagName, defaultValue);
    if (!enabled) {
        throw new Response(null, { status: 404 });
    } else {
        return null;
    }
}
